import axios from 'axios';
import {
	ORDER_SUCCESS,
	ORDER_FAILED,
	SET_ALERT,
	CLEAR_ORDER,
	GET_ORDER_SUCCESS,
	GET_ORDER_FAILED,
	GET_ADMIN_ORDER_FAILURE,
	GET_ADMIN_ORDER_SUCCESS,
	GET_ADMIN_ORDER_REQUEST,
	GET_ONE_ORDER_FAILURE,
	GET_ONE_ORDER_SUCCESS,
	UPDATE_ORDER_STATUS_SUCCESS,
	UPDATE_ORDER_STATUS_FAILURE,
	GET_CART_SUCCESS,
} from './index';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const createOrder = (cart_id, notes = '', po_number = '') => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const response = await axios.post(
			BASE_URL + '/api/createorder',
			{ cart_id, notes, po_number },
			config
		);
		dispatch({ type: ORDER_SUCCESS, payload: response.data });
		dispatch({ type: GET_CART_SUCCESS, payload: [] });
	} catch (e: any) {
		dispatch({ type: ORDER_FAILED });
		dispatch({
			type: SET_ALERT,
			payload: { message: e.response?.data?.error || 'Failed to create order', status: 'error' },
		});
	}
};

export const clearOrder = () => async (dispatch: any) => {
	dispatch({ type: CLEAR_ORDER });
};

export const getAllOrders = (offset, status = '') => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const params = new URLSearchParams({ offset: String(offset) });
		if (status) params.append('status', status);
		const response = await axios.get(
			BASE_URL + `/api/getorder?` + params.toString(),
			config
		);
		dispatch({ type: GET_ORDER_SUCCESS, payload: response.data });
	} catch (e) {
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Failed to fetch order', status: 'error' },
		});
		dispatch({ type: GET_ORDER_FAILED });
	}
};

export const getAllAdminOrders =
	(
		offset: number = 0,
		orderId = '',
		facility = '',
		email = '',
		status = '',
		startDate = '',
		endDate = ''
	) =>
	async (dispatch: any) => {
		dispatch({ type: GET_ADMIN_ORDER_REQUEST });
		const config = {
			headers: {
				'x-auth-token': localStorage.getItem('x-auth-token'),
			},
		};

		const body = {
			orderId,
			facility,
			email,
			status,
			startDate,
			endDate,
		};
		try {
			const response = await axios.post(
				BASE_URL + `/api/getadminorder?offset=` + offset,
				body,
				config
			);
			dispatch({ type: GET_ADMIN_ORDER_SUCCESS, payload: response.data });
			return Promise.resolve();
		} catch (e) {
			dispatch({
				type: SET_ALERT,
				payload: { message: 'Failed to fetch admin orders', status: 'error' },
			});
			dispatch({ type: GET_ADMIN_ORDER_FAILURE });
			return Promise.reject(e);
		}
	};

export const getUserOrder = (order_id) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const response = await axios.get(
			BASE_URL + `/api/getuserorder?order_id=` + order_id,
			config
		);
		dispatch({ type: GET_ONE_ORDER_SUCCESS, payload: response.data });
	} catch (e) {
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Failed to fetch user order', status: 'error' },
		});
		dispatch({ type: GET_ONE_ORDER_FAILURE });
	}
};

export const updateOrderStatus =
	(order_id, status) => async (dispatch: any) => {
		const config = {
			headers: {
				'x-auth-token': localStorage.getItem('x-auth-token'),
			},
		};
		const body = { order_id, status };
		try {
			const response = await axios.put(
				BASE_URL + '/api/updateorderstatus',
				body,
				config
			);
			dispatch({ type: UPDATE_ORDER_STATUS_SUCCESS, payload: response.data });
			dispatch({
				type: SET_ALERT,
				payload: {
					message: 'Order status updated successfully!',
					status: 'success',
				},
			});
			dispatch(getUserOrder(order_id)); // Refresh order details
		} catch (e) {
			dispatch({ type: UPDATE_ORDER_STATUS_FAILURE });
			dispatch({
				type: SET_ALERT,
				payload: { message: 'Failed to update order status', status: 'error' },
			});
		}
	};

export const updateEditedOrder = (order_id, items, notes = '', po_number = '') => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	const body = { order_id, items, notes, po_number };
	try {
		const response = await axios.post(
			BASE_URL + '/api/updateorder',
			body,
			config
		);
		// On success, treat it like a new order creation for the confirmation page
		dispatch({ type: ORDER_SUCCESS, payload: response.data });
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Order updated successfully!', status: 'success' },
		});
		return response.data; // Return the response data which includes the new orderId
	} catch (e) {
		dispatch({ type: ORDER_FAILED });
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Failed to update order', status: 'error' },
		});
		throw e; // Re-throw the error so the component can catch it
	}
};
